import api from './config';

const STORAGE_PREFERENCE_KEY = 'authStorage';

const clearAuthStorage = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('pseudo');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('pseudo');
    localStorage.removeItem(STORAGE_PREFERENCE_KEY);
};

const getPreferredStorage = () => {
    const preference = localStorage.getItem(STORAGE_PREFERENCE_KEY);
    if (preference === 'session') {
        return sessionStorage;
    }
    if (preference === 'local') {
        return localStorage;
    }
    if (localStorage.getItem('token')) {
        return localStorage;
    }
    if (sessionStorage.getItem('token')) {
        return sessionStorage;
    }
    return localStorage;
};

const getStoredToken = () => {
    return localStorage.getItem('token') || sessionStorage.getItem('token');
};

const authService = {
    register: async (pseudo, password, rememberMe = true) => {
        const response = await api.post('/api/comptes/register', {
            pseudo,
            password,
        });
        
        if (response.data.token) {
            const userData = response.data.data || response.data;
            const userId = userData.idcompte || userData.idCompte || userData.id;
            const userPseudo = userData.pseudo;
            
            clearAuthStorage();
            localStorage.setItem(STORAGE_PREFERENCE_KEY, rememberMe ? 'local' : 'session');
            const storage = getPreferredStorage();
            storage.setItem('token', response.data.token);
            storage.setItem('userId', String(userId));
            storage.setItem('pseudo', userPseudo);
        }
        return response.data.data || response.data;
    },

    login: async (pseudo, password, rememberMe = true) => {
        const response = await api.post('/api/comptes/login', {
            pseudo,
            password,
        });
        
        if (response.data.token) {
            const userData = response.data.data || response.data;
            const userId = userData.idcompte || userData.idCompte || userData.id;
            const userPseudo = userData.pseudo;
            
            clearAuthStorage();
            localStorage.setItem(STORAGE_PREFERENCE_KEY, rememberMe ? 'local' : 'session');
            const storage = getPreferredStorage();
            storage.setItem('token', response.data.token);
            storage.setItem('userId', String(userId));
            storage.setItem('pseudo', userPseudo);
        }
        return response.data.data || response.data;
    },

    logout: () => {
        clearAuthStorage();
    },

    isAuthenticated: () => {
        return !!getStoredToken();
    },

    getCurrentUser: () => {
        const storage = getPreferredStorage();
        const token = storage.getItem('token');
        const userId = storage.getItem('userId');
        const pseudo = storage.getItem('pseudo');
        
        if (!token || !userId) {
            return null;
        }
        
        const parsedId = parseInt(userId);
        if (isNaN(parsedId)) {
            return null;
        }
        
        return {
            idCompte: parsedId,
            pseudo: pseudo,
        };
    },
};

export default authService;